import * as universal from '../entries/pages/_slug_/_page.js';

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_slug_/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/[slug]/+page.js";
export const imports = ["_app/immutable/nodes/3.LLHJKNl2.js","_app/immutable/chunks/scheduler.RgLb8lSQ.js","_app/immutable/chunks/index.RLhuoQOD.js","_app/immutable/chunks/stores.iao9Q-QK.js","_app/immutable/chunks/entry.B3zzDB6w.js","_app/immutable/chunks/Content.CJyCs2p3.js"];
export const stylesheets = ["_app/immutable/assets/Content.Dyn1NPpS.css"];
export const fonts = [];
